import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { DependentHistoryContext } from "./DependentHistoryContext";

export const DependentHistoryDependences = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const dt1 = useRef(null);
    const { t, i18n } = useTranslation(["dependent-history", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;
    const title = "Lịch sử thay đổi thông tin người phụ thuộc";

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const sources = [
        { label: "Dân cư", value: "DC" },
        { label: "Định danh điện tử", value: "DDDT" },
        { label: "Căn cước công dân", value: "CCCD" },
    ];

    const dependentHistoryContext = useContext(DependentHistoryContext);
    const { dependentHistoryDialog, setDependentHistoryDialog, dependentHistories, setDependentHistories } = dependentHistoryContext;

    const [selectedHistory, setSelectedHistory] = useState(null);

    useEffect(() => {
        if (dependentHistories.length > 0) {
            setSelectedHistory(dependentHistories[0]);
        } else {
            setSelectedHistory(null);
        }
    }, [dependentHistories]);

    useEffect(() => { }, [selectedHistory]);

    const hideDialog = () => {
        setDependentHistoryDialog(false);
    };

    const updateSourceTemplateBody = (rowData) => {
        return <div className="flex align-items-left justify-content-left">{sources.find((e) => (e.value = rowData.updateSource))?.label}</div>;
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inherit" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    return (
        <Dialog visible={dependentHistoryDialog} style={{ width: "70%" }} header={title.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="grid mt-3">
                <div className="col-12">
                    {/* lịch sử thay đổi thông tin người phụ thuộc */}
                    <BlockDetail title={t("history.list")}>
                        <DataTable
                            ref={dt}
                            value={dependentHistories}
                            dataKey="stt"
                            className="datatable-responsive p-datatable-sm"
                            selectionMode="single"
                            selection={selectedHistory}
                            onSelectionChange={(e) => {
                                setSelectedHistory(e.value);
                            }}
                            showGridlines
                            totalRecords={dependentHistories.length | 0}
                            paginatorClassName="justify-content-start"
                            emptyMessage="Không có dữ liệu"
                            paginator
                            rows={10}
                            first={0}
                            paginatorTemplate={paginatorTemplate}
                        >
                            <Column field="stt" header={t("stt", { ns: "common" })} />
                            <Column field="idNumberDependent" className="text-center" header={t("dependent.idNumberDependent")} />
                            <Column field="stt" className="text-center" header={t("history.contentChanges")} />
                            <Column field="changeDate" className="text-center" header={t("history.changeDate")} />
                            <Column field="updateSource" className="text-center" header={t("history.updateSource")} body={updateSourceTemplateBody} />
                        </DataTable>
                    </BlockDetail>
                </div>

                <div className="col-12">
                    {/* thông tin chi tiết thay đổi thông tin người phụ thuộc */}
                    <BlockDetail title={t("history.list1")}>
                        <DataTable
                            ref={dt}
                            value={selectedHistory?.contents}
                            dataKey="stt"
                            className="datatable-responsive p-datatable-sm"
                            showGridlines
                            totalRecords={selectedHistory?.contents?.length | 0}
                            paginatorClassName="justify-content-start"
                            emptyMessage="Không có dữ liệu"
                            paginator
                            rows={10}
                            first={0}
                            paginatorTemplate={paginatorTemplate}
                        >
                            <Column field="stt" header={t("stt", { ns: "common" })} />
                            <Column field="field" className="text-center" header={t("history.field")} />
                            <Column field="valueBefore" className="text-center" header={t("history.valueBefore")} />
                            <Column field="valueAfter" className="text-center" header={t("history.valueAfter")} />
                        </DataTable>
                    </BlockDetail>
                </div>
            </div>

            <div className="grid">
                <div className="col-12">
                    {/* close */}
                    <Button
                        style={{
                            width: "max-content",
                        }}
                        className="mr-2 p-button-danger"
                        label={t("close", { ns: "common" })}
                        icon="pi pi-times"
                        onClick={hideDialog}
                    />
                </div>
            </div>
        </Dialog>
    );
};
